var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"maintenance"}},[_c('h1',[_vm._v(_vm._s(_vm.$t("onboard.maintenance.header")))]),_c('p',[_vm._v(_vm._s(_vm.$t('onboard.maintenance.text')))])])}
var staticRenderFns = []

export { render, staticRenderFns }